module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAeCAYAAAAcni9KAAAAAXNSR0IArs4c6QAAAOtJREFUOBFjYCAS/P//XwSIDwLxOyCOI0obUCEzEO8DYhh4TazGPpgOKH2DoEagwmg0TX+AfGe8GoEKDIH4G5rGYkKaQIHxAE3TMkKaQIGxF03TBSCfi5BG9MB4A9SkQEgTtsBwIaQJW2CUENI0BAIjAi3YQSkDf2CAPA1UdBlNI/7AgIYUE94QwycJtI08p4IMBWruRXMuKKUo4rMQLAdURF7ahNoqDDQAPTcsJ2grVDPpSQ5mMtDWKCBGBsTFK9TmgQks0nMLkn8pCizSSwQkm9EDi3CBDA1l9JRFXBUA1QxKWfuB+CEQRwEAja12qxtGICEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/image/back.png
// module id = Nfc2
// module chunks = 1